import { CapabilityGate, SubCapabilityKey } from "@next-platform/client-common-core/infra/application/capabilities";
import { Button, ButtonSize, ButtonVariant, TextArea } from "@next-platform/client-common-spicy-ui";

import { Col, Row } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";
import { CHAT_MESSAGE_MAX_LENGTH } from "@/pages/Chat/components/constants";

import { ChatBubbleEditBoxProps } from "./types";

const ChatBubbleEditBox = ({
  value = "",
  onChange,
  onCancel,
  onSettings,
  onSave,
  isSaving = false,
  isImageEditMode = false,
}: ChatBubbleEditBoxProps) => {
  return (
    <Col className="gap-md">
      <TextArea
        onChange={(value) => {
          onChange(value.slice(0, CHAT_MESSAGE_MAX_LENGTH));
        }}
        value={value}
        className="!bg-gray-4 !ring-0 !rounded-lg border-1 border-solid border-gray-10"
        rows={1}
        maxLength={CHAT_MESSAGE_MAX_LENGTH}
      />
      <Row className="justify-end gap-sm">
        <Button onClick={onCancel} disabled={isSaving} variant={ButtonVariant.TEXT} size={ButtonSize.LARGE} aria-label="cancel">
          <Trans i18nKey="common:cancel" />
        </Button>
        {isImageEditMode && onSettings ? (
          <CapabilityGate capability={SubCapabilityKey.ChatImageImageGenerationSettings}>
            <Button
              data-testid="ChatBubbleEditBoxSettings"
              onClick={onSettings}
              variant={ButtonVariant.SECONDARY}
              size={ButtonSize.LARGE}
              aria-label="settings"
            >
              <Trans i18nKey="common:settings" />
            </Button>
          </CapabilityGate>
        ) : null}
        <Button
          onClick={onSave}
          disabled={!value?.trim()}
          loading={isSaving}
          variant={ButtonVariant.TRANSPARENT}
          size={ButtonSize.LARGE}
          className="!bg-green-9 dark:!bg-green-5 text-white"
          aria-label="save"
        >
          {isImageEditMode ? <Trans i18nKey="common:generate" /> : <Trans i18nKey="common:save" />}
        </Button>
      </Row>
    </Col>
  );
};

export default ChatBubbleEditBox;
